import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, getDocs, getDoc, doc,query, where,updateDoc, onSnapshot   } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Carousel } from 'react-bootstrap';
import slide1 from './../../assets/images/slide1.jpg';
import slide from './../../assets/images/slide.png';
import iconPanier from './../../assets/images/Vector2.png';
import iconcalendar from './../../assets/images/Vector4.png';

const Panier = () => {
  const [acceptCommandes, setAcceptCommandes] = useState(null);
  const [showPickupTimeModal, setShowPickupTimeModal] = useState(false);
  const [horairesOuverture, setHorairesOuverture] = useState([]);
  const [availablePickupTimes, setAvailablePickupTimes] = useState([]);
  const [pickupTime, setPickupTime] = useState('');
  const [pickupTimeError, setPickupTimeError] = useState(false);
  const [panier, setPanier] = useState(() => {
    const storedPanier = localStorage.getItem('panier');
    return storedPanier ? JSON.parse(storedPanier) : [];
  });
    const navigate = useNavigate();
  // Met à jour le localStorage lorsque le panier change
  useEffect(() => {
    localStorage.setItem('panier', JSON.stringify(panier));
  }, [panier]);


      useEffect(() => {
        
          const fetchHorairesOuverture = async () => {
              try {
                  const horairesCollection = collection(db, 'horaires');
                  const horairesSnapshot = await getDocs(horairesCollection);
                  const horairesList = horairesSnapshot.docs.map(doc => ({
                      id: doc.id,
                      ...doc.data()
                  }));
                  setHorairesOuverture(horairesList);
             
              } catch (error) {
                  console.error("Error fetching horaires: ", error);
              }
          };
  
          fetchHorairesOuverture();
      }, []);
  
      useEffect(() => {
    
          if (panier.length && horairesOuverture.length) {
              const today = new Date().toLocaleDateString('fr-FR', { weekday: 'long' }).toLowerCase();
              const currentSeason = getCurrentSeason(); // Fonction pour déterminer la saison actuelle
              const horaires = horairesOuverture.find(h => h.jour === today);
        
              if (horaires) {
                  const seasonHoraires = horaires.saisons[currentSeason] || [];
                  const availableTimes = generateAvailableTimes(seasonHoraires);
                  setAvailablePickupTimes(availableTimes);
              } else {
                  setAvailablePickupTimes([]);
              }
          }
      }, [panier, horairesOuverture]);

        const getCurrentSeason = () => {
        const month = new Date().getMonth() + 1; // January is 0
        if (month >= 1 || month <= 5) return 'hiver';
        if (month >= 6 && month <= 9) return 'été';
        if (month >= 10 || month <= 12) return 'hiver';
        return 'autre'; // Adjust if you have more seasons
    };

    const generateAvailableTimes = (horaires) => {
        const availableTimes = [];
        const now = new Date();
        
        // Ajouter 20 minutes à l'heure actuelle
        now.setMinutes(now.getMinutes() + 20);
        
        // Arrondir au prochain intervalle de 15 minutes
        const minutes = now.getMinutes();
        const roundedMinutes = Math.ceil(minutes / 15) * 15;
        now.setMinutes(roundedMinutes);
        now.setSeconds(0); // Réinitialiser les secondes à 0
    
        const currentTime = now.toTimeString().substring(0, 5);
        
        horaires.forEach(({ début, fin }) => {
            let startTime = new Date(`1970-01-01T${début}:00`);
            const endTime = new Date(`1970-01-01T${fin}:00`);
            
            // Vérifier si l'heure actuelle ajustée est avant la fin de la plage horaire
            if (currentTime <= endTime.toTimeString().substring(0, 5)) {
                // Si l'heure de début est avant l'heure actuelle, ajuster l'heure de début à l'heure actuelle
                if (startTime.toTimeString().substring(0, 5) < currentTime) {
                    startTime = new Date(`1970-01-01T${currentTime}:00`);
                }
                
                // Cloner startTime pour éviter de modifier l'heure de début originale
                let tempStartTime = new Date(startTime);
    
                // Générer les heures disponibles
                while (tempStartTime <= endTime) {
                    availableTimes.push(tempStartTime.toTimeString().substring(0, 5));
                    tempStartTime.setMinutes(tempStartTime.getMinutes() + 15); // Intervalle de 15 minutes
                }
            }
        });
    
        return availableTimes;
    };

  const updateQuantity = (id, change) => {
    setPanier((prevPanier) =>
      prevPanier.map((item) =>
        item.id === id
          ? {
              ...item,
              quantite: Math.max(1, item.quantite + change), // Minimum 1
            }
          : item
      )
    );
  };

  const getItemTotal = (item) => {
  const prixPlat = parseFloat(item.prix) || 0;

  // Somme des prix des addons
  const prixAddons = item.addons
    ? item.addons.reduce((sum, addon) => {
        return (
          sum +
          addon.modules.reduce(
            (modSum, module) => modSum + (parseFloat(module.prix) || 0),
            0
          )
        );
      }, 0)
    : 0;

  return (prixPlat + prixAddons) * item.quantite;
};  
  const removeItem = (id) => {
    setPanier((prevPanier) => prevPanier.filter((item) => item.id !== id));
  };

const getTotal = () =>
  panier
    .reduce((total, item) => {
      const prixPlat = parseFloat(item.prix) || 0;

      // Somme des prix addons
      const prixAddons = item.addons
        ? item.addons.reduce((sum, addon) => {
            return (
              sum +
              addon.modules.reduce(
                (modSum, module) => modSum + (parseFloat(module.prix) || 0),
                0
              )
            );
          }, 0)
        : 0;

      // prix total = (plat + addons) * quantité
      return total + (prixPlat + prixAddons) * item.quantite;
    }, 0)
    .toFixed(2);

  const handleCheckout = () => {
    if (panier.length === 0 || acceptCommandes==false ) {
        return;
    }

    setShowPickupTimeModal(true); // Show pickup time modal
  };

   const handlePickupTimeSubmit = () => {
        if (!pickupTime) {
            setPickupTimeError(true);
            return;
        }
        setPickupTimeError(false);
        setShowPickupTimeModal(false);
    
        navigate('/checkout', { state: { pickupTime } });
    };

  return (
    <div className="mt-5">
   <div class="section-hero">
                     <h2 class="titre-hero">Détails de la commande</h2>
                </div>
        {panier.length === 0 ? (
    <div className="text-center card-vide-pn">
      <h5 className='vide-pn2'><strong>Votre panier est vide pour le moment. </strong><br/>
        Explorez notre boutique et remplissez-le avec vos plats préférés !</h5>
      <Link to="/boutique">
        <button className="btn btn-red btn-size mt-3">Retourner à la boutique</button>
      </Link>
    </div>
  ) : (
<   div className="content mrg-pg">
      <div className="row">
        <div className="col-md-9 pr-4 desktop-hd">
            <Carousel className="custom-carousel">
            
                <Carousel.Item>
                    <img
                        className="d-block w-100 img-couv"
                    src={slide}
                        alt=""
                    />
                </Carousel.Item>

               
            </Carousel>
        </div>
        <div className="col-md-3 flexX">
              <Link className="btn-acc btn-panier d-block w-100 mb-3" to="/boutique">
                  <img
                      className="d-block icon-btn "
                      src={iconPanier}
                      alt=""
                  />
                  <span>Voir le menu</span>
              </Link>
              <Link className="btn-acc btn-cldr d-block w-100" to="/panier">
                  <img
                      className="d-block icon-btn"
                      src={iconcalendar}
                      alt=""
                  />
                  <span> Réserver une table</span>
              </Link>
        </div>
        <div className="col-md-7 marg-panier">
          <div className="bg-cart cart-padd rounded">
          
          <ul className="list-group">
              {panier.map(item => (
              <li
                  key={item.id}
                  className="card-item-cart"
              >
              <div className="d-flex align-items-center justify-content-start">
                  <div className='col-2 pr-2 pl-0'>
                     {item.image  && (
                                    <img src={item.image} className="img-cart" alt={item.nom} />
                                )}  
                  </div>
                  <div className='col-6 '>
                      <div className='item-name'> {item.nom} <span>({item.prix}€)</span></div>
                      <div className='item-desc'> {item.description}</div>
                      {/* Afficher les addons */}
                                    {item.addons && item.addons.length > 0 && (
                                    <div className='item-addons'>
                                        {item.addons.map((addon) =>
                                        addon.modules.map((module, idx) => (
                                            <div key={idx} className='addon-line'>
                                            + {module.nom} ({module.prix}€)
                                            </div>
                                        ))
                                        )}
                                    </div>
                                    )}
                      <div className='item-prix'> {getItemTotal(item).toFixed(2)}€ </div>
                  </div>
                  <div className='col-4 '>
                        <div className='d-flex align-items-center justify-content-start'> 
                              <div className='col-4'>  
                                <Link
                  className="btn-item btn-minus"
                  onClick={() => updateQuantity(item.id, -1)}
                  ><FontAwesomeIcon icon={faMinus} /></Link>
                  </div> 
                      
                      <div className='col-3'>
                      <p className='pr-cart'>{item.quantite}</p>
                      </div>
                      <div className='col-3'>
                      <Link
                          className="btn-item btn-plus"
                          onClick={() => updateQuantity(item.id, 1)} 
                      >
                          <FontAwesomeIcon icon={faPlus} />
                      </Link>
                        </div>
                        <div className='col-1'>
                     <button
                        className="btn btn-delete-pn"
                        onClick={() => removeItem(item.id)}
                        >
                        <FontAwesomeIcon icon={faTimes} />
                        </button>
                        </div>
                  </div>
                    </div>
              </div>
              </li>
              ))}
          </ul>
          
          
          </div>
        
        </div>
        <div className="col-md-5 marg-panier">
            <div className="bg-cart bg-cart2 rounded">
            <h5 className='tl-cart'>Récapitulatif de commande</h5>
            <p className="d-flex justify-content-between sous-total">
        <span>Sous-Total</span>
        <span className="red-color">{getTotal()} €</span>
      </p>
      
      <p className="d-flex justify-content-between total">
        <span>Total</span>
        <span className="red-color">{getTotal()} €</span>
      </p>
            
            <button
                className="vl-cart mt-5"
                onClick={handleCheckout}
                disabled={panier.length === 0}
            >
                Commander
            </button>
            </div>
            
        </div>


      </div>
    </div>









//       <div className="row">
//         <div className="col-md-8 ovrf-scroll">
//           <table className="table align-middle panier-tbl">
//             <thead>
//               <tr>
//                 <th>Plats</th>
//                 <th>Prix</th>
//                 <th>Quantité</th>
//                 <th>Subtotal</th>
//                 <th></th>
//               </tr>
//             </thead>
//             <tbody>
//   {panier.map((item) => (
//     <tr key={item.id} className="align-middle">
//       <td >
//         <div className="align-items-center display-desk">
//         <img src={item.image} alt={item.nom} width="80" height="80" className="me-3" />
//         <span>{item.nom}</span>
//         </div>
//         <div className="align-items-center display-mbl">
//         <img src={item.image} alt={item.nom} width="80" height="80" className="me-3" />
//         <span>{item.nom}</span>
//         </div>
//       </td>
//       <td className="align-middle">{(parseFloat(item.prix) || 0).toFixed(2)} €</td>
//       <td className="align-middle">
//         <div className="d-flex align-items-center">
//           <button
//             className="btn btn-qut-pn me-2"
//             onClick={() => updateQuantity(item.id, -1)}
//           >
//             <FontAwesomeIcon icon={faMinus} />
//           </button>
//           <span>{item.quantite}</span>
//           <button
//             className="btn btn-qut-pn ms-2"
//             onClick={() => updateQuantity(item.id, 1)}
//           >
//             <FontAwesomeIcon icon={faPlus} />
//           </button>
//         </div>
//       </td>
//       <td className="align-middle">{(parseFloat(item.prix) * item.quantite).toFixed(2)} €</td>
//       <td className="align-middle">
//         <button
//           className="btn btn-delete-pn"
//           onClick={() => removeItem(item.id)}
//         >
//           <FontAwesomeIcon icon={faTimes} />
//         </button>
//       </td>
//     </tr>
//   ))}
// </tbody>

//           </table>
//         </div>
//         <div className="col-md-4">
//           <div className="card shadow-sm">
//             <div className="card-body">
//               <h5 className="card-title">Total</h5>
             
//               <p className="d-flex justify-content-between sous-total">
//                 <span>Sous-Total</span>
//                 <span className="red-color">{getTotal()} €</span>
//               </p>
//               <hr />
//               <p className="d-flex justify-content-between total">
//                 <span>Total</span>
//                 <span className="red-color">{getTotal()} €</span>
//               </p>
//               <button className="btn btn-red2 w-100"     
//                       onClick={handleCheckout}
//                       disabled={panier.length === 0}>Commander</button>
//             </div>
//           </div>
//         </div>
//       </div>
  )}
       {/* basePriceal for Pickup Time */}
          <Modal show={showPickupTimeModal} onHide={() => setShowPickupTimeModal(false)} centered>
              <Modal.Header closeButton>
              </Modal.Header>
              <Modal.Body className='py-5'>
              <Modal.Title className="text-center w-100 modal-titre mb-3">Heure de retrait</Modal.Title>
                  <p className="text-center w-100 modal-text">Choisissez l'heure à laquelle vous souhaitez passer récupérer votre commande.</p>
                  <Form>
                      <Form.Group controlId="pickupTime">
                      <div className="d-flex justify-content-center">
                          <div className='col-6'>
                          <Form.Control
                              className={`form-modal ${pickupTimeError ? 'is-invalid' : ''}`}
                              as="select"
                              value={pickupTime}
                              onChange={(e) => {
                                  setPickupTime(e.target.value);
                                  if (pickupTimeError) {
                                      setPickupTimeError(false); // Supprimer l'erreur dès qu'une valeur est sélectionnée
                                  }
                              }}
                              required
                          >
                              <option value="">Sélectionner une heure</option>
                              {availablePickupTimes.map((time, index) => (
                                  <option key={index} value={time}>{time}</option>
                              ))}
                          </Form.Control>
                          {pickupTimeError && (
                              <div className="invalid-feedback" style={{ color: 'red' }}>
                                  Veuillez sélectionner une heure de récupération.
                              </div>
                          )}
                          </div>
                          <div className='col-6'>
                          <Button className='btn-size btn-red2 w-100' onClick={handlePickupTimeSubmit}>Confirmer</Button>
                          </div>
                      </div>    
                      </Form.Group>
                      
                  </Form>
              </Modal.Body>
          </Modal>
    </div>



  );
};

export default Panier;
